import {FC, memo} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {IAttachmentData} from '@kcast-fe/core';
import {useElementWidth} from '@kcast-fe/ui-kit';

import {RenderImage} from './components';

interface IProps {
  isMyMsg: boolean;
  isMsgHasText: boolean;
  images: Array<IAttachmentData>;
}

const RenderImageListFC: FC<IProps> = ({isMyMsg, isMsgHasText, images}) => {
  const [ref, width] = useElementWidth<HTMLDivElement>();

  return (
    <Flex ref={ref} flexDirection={'column'} gap={'24px'}>
      {images.map((attachment) => (
        <Box key={attachment.url} data-testid={'attached-image'}>
          <RenderImage
            widthPx={width}
            isMyMsg={isMyMsg}
            attachment={attachment}
            isMsgHasText={isMsgHasText}
          />
        </Box>
      ))}
    </Flex>
  );
};

export const RenderImageList = memo(RenderImageListFC);
